import React, { useEffect, useState } from "react";
import moment from "moment";
import { Link, useParams } from "react-router-dom";
import PhoneInput from "react-phone-number-input";
import uploadImg from "../../assets/images/upload.svg";
import api from "../../api";
import { notify } from "../../utils/toast";
export const EmployeeDetail = () => {
  const [loader, setLoader] = useState(false);
  const params = useParams();
  const [data, setData] = useState({});
  const [phoneNum, setPhoneNum] = useState("");

  const getData = async () => {
    try {
      const response = await api.getEmployee(params?.id);
      console.log(response);
      if (response?.success) {
        setData(response?.employee || {});
      } else {
      }
    } catch (error) {
      notify.error("Something went wrong");
    }
  };

  useEffect(() => {
    if (params?.id) {
      getData(params?.id);
      console.log(params?.id);
    }
  }, []);

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY");
    return dateTemp;
  };

  return (
    <>
      {/* Begin Page Content */}
      <div className="DashboardMain">
        {data?.fullName ? (
          <>
            {/* 1. personal deatil */}
            <div className="card sortby-box br-10 border-transparent mt-3">
              <div className="card-header br-10  bg-white border-transparent py-3 ">
                <div className="empFormMain">
                  <div className="titleRow">
                    <div className="title">1. Personal Info</div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="dRow">
                        <div className="title">Full Name:</div>
                        <div className="value">{data?.fullName}</div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="dRow">
                        <div className="title">Date Of Birth:</div>
                        <div className="value">
                          {data?.dob ? formatDate(data?.dob) : "-"}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="dRow">
                        <div className="title">Gender:</div>
                        <div className="value">{data?.gender}</div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="dRow">
                        <div className="title">Nationality:</div>
                        <div className="value">{data?.nationality}</div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="dRow">
                        <div className="title">Contact:</div>
                        <div className="value">{data?.contactNumber}</div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="dRow">
                        <div className="title">Email:</div>
                        <div className="value">{data?.email}</div>
                      </div>
                    </div>
                    <div className="col-md-12">
                      <div className="dRow">
                        <div className="title">Address:</div>
                        <div className="value">{data?.address}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* 2. Employement Detail */}
            <div className="card sortby-box br-10 border-transparent mt-3">
              <div className="card-header br-10  bg-white border-transparent py-3 ">
                <div className="empFormMain">
                  <div className="titleRow">
                    <div className="title">2. Employement Detail</div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="dRow">
                        <div className="title">Job Title:</div>
                        <div className="value">{data?.jobTitle}</div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="dRow">
                        <div className="title">Department:</div>
                        <div className="value">{data?.department}</div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="dRow">
                        <div className="title">Employement Type:</div>
                        <div className="value">{data?.employmentType}</div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="dRow">
                        <div className="title">Work Location:</div>
                        <div className="value">{data?.workLocation}</div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="dRow">
                        <div className="title">Joining Date:</div>
                        <div className="value">
                          {data?.joiningDate
                            ? formatDate(data?.joiningDate)
                            : "-"}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="dRow">
                        <div className="title">Contract End Date:</div>
                        <div className="value">
                          {data?.contractEndDate
                            ? formatDate(data?.contractEndDate)
                            : "-"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* 3. bank detail */}
            <div className="card sortby-box br-10 border-transparent mt-3">
              <div className="card-header br-10  bg-white border-transparent py-3 ">
                <div className="empFormMain">
                  <div className="titleRow">
                    <div className="title">3. Payroll & Bank Information</div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="dRow">
                        <div className="title">Salary:</div>
                        <div className="value">{data?.baseSalary || "-"}</div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="dRow">
                        <div className="title">Currency:</div>
                        <div className="value">{data?.currency || "-"}</div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="dRow">
                        <div className="title">Bank Account Holder Name:</div>
                        <div className="value">
                          {data?.bankAccountHolderName || "-"}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="dRow">
                        <div className="title">Bank Name:</div>
                        <div className="value">{data?.bankName || "-"}</div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="dRow">
                        <div className="title">Account Number / IBAN:</div>
                        <div className="value">
                          {data?.accountNumber || "-"}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="dRow">
                        <div className="title">SWIFT/BIC Code:</div>
                        <div className="value">{data?.swiftCode || "-"}</div>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="dRow">
                        <div className="title">
                          Tax ID / Social Security Number:
                        </div>
                        <div className="value">{data?.taxId || "-"}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* 4. system & Attendance Details */}
            <div className="card sortby-box br-10 border-transparent mt-3">
              <div className="card-header br-10  bg-white border-transparent py-3 ">
                <div className="empFormMain">
                  <div className="titleRow">
                    <div className="title">4. System & Attendance Details</div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="dRow">
                        <div className="title">Working Hours Policy:</div>
                        <div className="value">
                          {data?.workingHoursPolicy || "-"}
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="dRow">
                        <div className="title">Overtime Eligibility:</div>
                        <div className="value">
                          {data?.overtimeEligibility ? "yes" : "No"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* 5. Document */}
            <div className="card sortby-box br-10 border-transparent mt-3">
              <div className="card-header br-10  bg-white border-transparent py-3 ">
                <div className="empFormMain">
                  <div className="titleRow">
                    <div className="title">5. Document</div>
                  </div>
                  <div className="row">
                    <div className="col-md-4">
                      <div className="uploadCard">
                        {data?.documents?.nationalId ? (
                          <div className="text-center">
                            <a
                              href={`${process.env.REACT_APP_SERVER_BASE_URL}/uploadedFiles/${data?.documents?.nationalId}`}
                              download={`NationalID_${data?.fullName}`}
                              target="_blank"
                            >
                              National ID
                            </a>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="uploadCard">
                        {data?.documents?.contract ? (
                          <div className="text-center">
                            <a
                              href={`${process.env.REACT_APP_SERVER_BASE_URL}/uploadedFiles/${data?.documents?.contract}`}
                              download={`offerLetter_${data?.fullName}`}
                              target="_blank"
                            >
                              Offer Letter
                            </a>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="uploadCard">
                        {data?.documents?.otherDocument ? (
                          <div className="text-center">
                            <a
                              href={`${process.env.REACT_APP_SERVER_BASE_URL}/uploadedFiles/${data?.documents?.otherDocument}`}
                              download={`otherDocument_${data?.fullName}`}
                              target="_blank"
                            >
                              Other Document
                            </a>
                          </div>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <h3>No data available</h3>
        )}
      </div>
      {/* /.container-fluid */}
    </>
  );
};
